export const PROGRAM = import.meta.env.MYFLYP_PROGRAM
export const API_BASE_URL = import.meta.env.MYFLYP_API_BASE_URL
export const FIREBASE_API_KEY = import.meta.env.FIREBASE_API_KEY
export const FIREBASE_AUTH_DOMAIN = import.meta.env.FIREBASE_AUTH_DOMAIN
export const FIREBASE_PROJECT_ID = import.meta.env.FIREBASE_PROJECT_ID
export const FIREBASE_STORAGE_BUCKET = import.meta.env.FIREBASE_STORAGE_BUCKET
export const FIREBASE_MESSAGE_SENDING_ID = import.meta.env
  .FIREBASE_MESSAGE_SENDING_ID
export const FIREBASE_APP_ID = import.meta.env.MYFLYP_FIREBASE_APP_ID
export const GDRIVE_BASE_URL = "https://lh3.googleusercontent.com/d"
export const SENTRY_DNS = import.meta.env.MYFLYP_SENTRY_DNS
export const SENTRY_ENABLED = Boolean(import.meta.env.MYFLYP_SENTRY_ENABLED)

export const isDev = import.meta.env.DEV

export const forbiddenRoutes = []
